'use client';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import React, { useEffect, useState } from 'react';
import Api, { apiPaths } from '../../../services/api';
import Num2persian from 'num2persian';

import ConfirmationModal from './ConfirmationModal';
import WithControllerImageUpload from 'app/components/ImageUpload/WithControllerImageUpload';

import { DecimalInput, NumberInput } from 'react-hichestan-numberinput';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';

const WithControllerNumberInput = ({
  control,
  errors,
  name,
  placeholder,
  isPrice = false,
  width,
  ...props
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <>
          {' '}
          {isPrice ? (
            <DecimalInput
              {...props}
              value={value}
              onChange={onChange}
              dir="rtl"
              // numberFormat='LATIN'
              placeholder={placeholder}
              className={`p-2 border rounded ${width ? width : 'w-full'}`}
            />
          ) : (
            <NumberInput
              {...props}
              value={value}
              onChange={onChange}
              dir="rtl"
              numberFormat="LATIN"
              placeholder={placeholder}
              className={`p-2 border rounded ${width ? width : 'w-full'}`}
            />
          )}
          {errors[name] && (
            <p className="text-red-500 text-sm mt-1" role="alert">
              {errors[name].message}
            </p>
          )}
        </>
      )}
    />
  );
};

const NewWarranty = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { enqueueSnackbar } = useSnackbar();

  const [phones, setPhones] = useState({});
  const [brands, setBrands] = useState();
  const [isFree, setIsFree] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [warrantyUuid, setWarrantyUuid] = useState('');

  const {
    control,
    handleSubmit,
    watch,
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    Api.post(`${apiPaths.PHONES}/list/seller`, {}).then((res) => {
      // console.log(res.data);
      setPhones(res.data);
      const bs = Object.keys(res.data)
        .map((k) => {
          return { label: k, value: k };
        })
        .sort(function (a, b) {
          if (a.value < b.value) {
            return -1;
          }
          if (a.value > b.value) {
            return 1;
          }
          return 0;
        });
      setBrands(bs);
    });
  }, []);

  const beforeSubmit = () => {
    setShowConfirmationModal(true);
  };

  const onSubmit = async (data, e) => {
    e?.preventDefault();
    // console.log(data);
    setShowConfirmationModal(false);
    enqueueSnackbar('در حال فعال سازی گارانتی...');

    const selectedPhone = phones[data.brand.value].find((p) => p.model === data.model.value);

    // within 50 percent range
    if (
      selectedPhone &&
      selectedPhone.price &&
      (selectedPhone.price * 0.25 > data.price || selectedPhone.price * 4 < data.price)
    ) {
      enqueueSnackbar('قیمت دستگاه وارد شده احتمالا اشتباه است', 'error');
      return;
    }

    Api.post(`${apiPaths.WARRANTIES}/admin`, {
      ...data,
      // uuid: data?.warranty_number?.value,
      warranty_number: data?.warranty_number,
      brand: data?.brand?.value,
      model: data?.model?.value,
      phone_uuid: selectedPhone?.uuid,
      product_price: data.price,
      vat_price: calculateTaxPrice(calculateWarrantyPrice(data.price)),
      warranty_price: calculateWarrantyPrice(data.price),
    })
      .then((res) => {
        navigate(location.pathname.replace('/add', ''));

        // if (res && res.url) {
        //   window.location.href = res.url;
        // }
        // console.log(res);
        // toast.success(
        //   "لینک فعال‌سازی برای خریدار ارسال شد. لطفا اطلاع رسانی نمایید",
        //   {
        //     duration: 20000,
        //   }
        // );
        // router.push("/seller");
      })
      .catch((e) => {
        console.log(e);
        enqueueSnackbar(e, 'error');
      });
    console.log(data);
  };

  const watchBrand = watch('brand');
  const watchPrice = watch('price');
  const watchImei = watch('imei');
  const watchSerial = watch('warranty_number');

  const toWrittenFormat = (price) => {
    return Num2persian(price);
  };
  const calculateWarrantyPrice = (price) => {
    if (isFree) return 0;
    if (price <= 15_000_000) return 600_000;
    // Calculate 4% of the entered price
    return Math.ceil((price * 4) / 100);
  };
  const calculateTaxPrice = (price) => {
    return 0;
    const VAT = 10;

    // Calculate 4% of the entered price
    return Math.ceil((price * VAT) / 100);
  };

  useEffect(() => {
    if (watchSerial && watchSerial.length > 7) {
      Api.get(`${apiPaths.WARRANTIES}/byserial/${watchSerial}`).then((res) => {
        console.log('here', res?.uuid);
        setWarrantyUuid(res?.uuid);
      });
    }
  }, [watchSerial]);

  useEffect(() => {
    if (watchImei?.length === 15) {
      Api.get(`${apiPaths.WARRANTIES}/imei-free/${watchImei}`).then((res) => {
        console.log('here', res);
        if (res === true) {
          setIsFree(true);
        } else {
          setIsFree(false);
        }
      });
    }
  }, [watchImei]);

  return (
    <div className="flex justify-center items-center ">
      <form
        dir="rtl"
        className="bg-white p-8 rounded-lg w-[400px]"
        onSubmit={handleSubmit(beforeSubmit)}
      >
        <h2 className="text-primary text-2xl mb-4">فعال‌سازی گارانتی</h2>

        <div className="mb-4 relative ">
          <div className="flex items-center gap-2">
            <WithControllerNumberInput
              errors={errors}
              control={control}
              // width="w-4/5"
              // disabled={!isManual}
              maxLength={15}
              placeholder="شماره سریال گارانتی"
              {...register('warranty_number', {
                required: 'شماره سریال الزامی است',
              })}
            />
            {/* <button
              className=" bg-primary text-white rounded p-2 px-3"
              type="button"
              onClick={() => {
                setshowSerialReader(true);
              }}
            >
              اسکن
            </button> */}
          </div>

          {/* <input
            type="text"
            placeholder=" شماره سریال گارانتی"
            // disabled
            maxLength={15}
            className={`p-2 border rounded w-4/5 ${
              errors.warranty_number ? "border-red-500" : ""
            }`}
            {...register("warranty_number", {
              required: "شماره سریال الزامی است",
              // pattern: {
              //   value: /^\d{15}$/,
              //   message: "IMEI باید ۱۵ رقم باشد",
              // },
            })}
          />
          {errors.warranty_number && (
            <p className="text-red-500 text-sm mt-1" role="alert">
              {errors.warranty_number.message}
            </p>
          )} */}
          {/* <div className="bg-yellow-300 absolute cursor-pointer w-6 h-6 flex justify-center items-center rounded-full p-2">؟</div> */}
          <p className="text-xs mt-1 font-light"> مثال: 000022995</p>
        </div>

        <div className="mb-4">
          <Controller
            name="brand"
            control={control}
            // defaultValue={}
            render={({ field }) => (
              <Select
                {...field}
                className="w-full"
                placeholder="انتخاب برند"
                options={brands}
                // isRtl
                {...register('brand', {
                  required: 'برند الزامی است',
                })}
                onChange={(selectedOption) => setValue('brand', selectedOption)}
              />
            )}
          />
          {errors.brand && (
            <p className="text-red-500 text-sm mt-1" role="alert">
              {errors.brand.message}
            </p>
          )}
        </div>

        <div className="mb-4">
          <Controller
            name="model"
            control={control}
            // defaultValue=""
            render={({ field }) => (
              <Select
                {...field}
                key={JSON.stringify(watchBrand)}
                className="w-full"
                {...register('model', {
                  required: 'مدل الزامی است',
                })}
                placeholder="انتخاب مدل"
                // @ts-ignore
                options={
                  watchBrand && watchBrand.value && phones[watchBrand.value]
                    ? phones[watchBrand.value].map((b) => {
                        return { label: b.model, value: b.model };
                      })
                    : []
                }
                isRtl
                onChange={(selectedOption) => {
                  setValue('model', selectedOption);
                }}
              />
            )}
          />
          {errors.model && (
            <p className="text-red-500 text-sm mt-1" role="alert">
              {errors.model.message}
            </p>
          )}
        </div>
        {warrantyUuid && (
          <div>
            <div className="mb-1 relative flex justify-between items-center">
              عکس جعبه
              <WithControllerImageUpload
                id="box-picture"
                control={control}
                {...register('box_picture', {
                  required: 'عکس جعبه الزامی است',
                })}
                fileInfo={{
                  purpose: 'box_pic',
                  file_type: 'image',
                  entity_name: 'warranty',
                  entity_uuid: warrantyUuid ? warrantyUuid : watchSerial,
                }}
              />
            </div>
            {errors.box_picture && (
              <p className="text-red-500 text-sm" role="alert">
                {errors.box_picture.message}
              </p>
            )}
            <p className="text-xs font-light mt-4">
              از قسمتی که برچسب کد IMEI روی جعبه قرار دارد، عکس بگیرید
            </p>
          </div>
        )}
        {warrantyUuid && (
          <div className="mb-4">
            <div className="mt-6 mb-1 relative flex justify-between items-center">
              عکس فاکتور
              <WithControllerImageUpload
                id="factor-pic"
                control={control}
                {...register('factor_picture', {
                  required: 'عکس فاکتور الزامی است',
                })}
                fileInfo={{
                  purpose: 'factor_pic',
                  file_type: 'image',
                  entity_name: 'warranty',
                  entity_uuid: warrantyUuid ? warrantyUuid : watchSerial,
                }}
              />
            </div>
            {errors.factor_picture && (
              <p className="text-red-500 text-sm" role="alert">
                {errors.factor_picture.message}
              </p>
            )}
          </div>
        )}

        <div className="mb-4 relative ">
          <div className="flex items-center gap-2">
            <input
              type="text"
              placeholder="IMEI"
              // disabled={!isManual}
              maxLength={15}
              className={`p-2 border rounded w-full ${errors.imei ? 'border-red-500' : ''}`}
              {...register('imei', {
                required: 'IMEI الزامی است',
                pattern: {
                  value: /^\d{15}$/,
                  message: 'IMEI باید ۱۵ رقم باشد',
                },
              })}
            />
            {/* <button
              className=" bg-primary text-white  rounded p-2 px-3"
              type="button"
              onClick={() => {
                setShowQrReader(true);
              }}
            >
              اسکن
            </button> */}
          </div>
          {errors.imei && (
            <p className="text-red-500 text-sm mt-1" role="alert">
              {errors.imei.message}
            </p>
          )}
        </div>

        <div className="mb-4">
          <WithControllerNumberInput
            errors={errors}
            control={control}
            maxLength={11}
            placeholder="شماره تماس خریدار"
            {...register('customer_mobile', {
              required: 'شماره تماس خریدار الزامی است',
              minLength: {
                value: 11,
                message: 'شماره صحیح نیست',
              },
              maxLength: {
                value: 11,
                message: 'شماره صحیح نیست',
              },
            })}
          />
        </div>

        <div className="mb-4 relative">
          <input
            type="text"
            placeholder="نام خریدار"
            className={`w-full p-2 border rounded ${errors.first_name ? 'border-red-500' : ''}`}
            {...register('first_name', {
              required: 'نام الزامی است',
            })}
          />
          {errors.first_name && (
            <p className="text-red-500 text-sm mt-1" role="alert">
              {errors.first_name.message}
            </p>
          )}
          {/* <button className="absolute top-1 bg-primary text-white mr-2 p-1 rounded-sm" type="button" onClick={() => setShowQrReader(true)}>Scan</button> */}
        </div>
        <div className="mb-4 relative">
          <input
            type="text"
            placeholder="نام خانوادگی خریدار"
            className={`w-full p-2 border rounded ${errors.last_name ? 'border-red-500' : ''}`}
            {...register('last_name', {
              required: 'نام الزامی است',
            })}
          />
          {errors.last_name && (
            <p className="text-red-500 text-sm mt-1" role="alert">
              {errors.last_name.message}
            </p>
          )}
          {/* <button className="absolute top-1 bg-primary text-white mr-2 p-1 rounded-sm" type="button" onClick={() => setShowQrReader(true)}>Scan</button> */}
        </div>

        <div className="mb-4">
          <WithControllerNumberInput
            errors={errors}
            control={control}
            maxLength={10}
            placeholder="کد ملی"
            {...register('customer_national_number', {
              required: 'کد ملی الزامی است',
              pattern: {
                value: /^\d{10}$/,
                message: 'کد ملی باید ۱۰ رقم باشد',
              },
            })}
          />
        </div>
        <div className="flex items-center gap-2">
          <WithControllerNumberInput
            // name="price"
            isPrice
            errors={errors}
            control={control}
            placeholder="قیمت دستگاه(تومان)"
            {...register('price', {
              required: 'قیمت الزامی است',
            })}
          />
          {typeof watchPrice != 'undefined' && <span className="absolute left-2 top-2">تومان</span>}
        </div>
        {typeof watchPrice != 'undefined' && watchPrice > 0 && (
          <div className="mb-4">
            <p className="text-lg font-bold">
              قیمت گوشی: <span className="text-base">{toWrittenFormat(watchPrice)} </span>
              <span className="text-base">تومان</span>
            </p>
          </div>
        )}
        {typeof watchPrice != 'undefined' && (
          <div className="mb-4">
            <p className="text-lg font-bold">
              قیمت گارانتی:{' '}
              {calculateWarrantyPrice(watchPrice)
                // + calculateTaxPrice(calculateWarrantyPrice(watchPrice))
                .toLocaleString('fa-IR')}{' '}
              <span className="text-base">تومان</span>
            </p>
          </div>
        )}
        {/* {typeof watchPrice != 'undefined' && (
          <div className="mb-4">
            <p className="text-lg font-bold">
              ۱۰ درصد مالیات ارزش افزوده گارانتی:{' '}
              {calculateTaxPrice(calculateWarrantyPrice(watchPrice)).toLocaleString('fa-IR')}{' '}
              <span className="text-base">تومان</span>
            </p>
          </div>
        )} */}
        {typeof watchPrice != 'undefined' && (
          <div className="mb-4">
            <p className="text-lg font-bold">
              مجموع پرداختی:{' '}
              {(
                calculateWarrantyPrice(watchPrice) +
                calculateTaxPrice(calculateWarrantyPrice(watchPrice))
              ).toLocaleString('fa-IR')}{' '}
              <span className="text-base">تومان</span>
            </p>
          </div>
        )}

        <div>
          <button
            disabled={!warrantyUuid}
            type="submit"
            className="bg-primary mt-4 w-full text-white p-2 rounded disabled:bg-gray-300"
          >
            ثبت
          </button>
        </div>
      </form>
      {showConfirmationModal && (
        <ConfirmationModal
          warrantyData={getValues()}
          isOpen={showConfirmationModal}
          loading={false}
          onSubmit={(e) => onSubmit(getValues(), e)}
          onClose={() => setShowConfirmationModal(false)}
        />
      )}
    </div>
  );
};

export default NewWarranty;
